import { cn } from "@/lib/utils";
import { BiSearch } from "react-icons/bi";

export const SearchInput = ({
  placeholder,
  value,
  onChange,
  className,
  variant = "default",
}: {
  placeholder?: string;
  value?: string;
  onChange?: (value: string) => void;
  className?: string;
  variant?: "default" | "small" | "large";
}) => {
  return (
    <label htmlFor="search" className={cn("relative w-full max-w-xs", className)}>
      <input
        type="search"
        placeholder={placeholder ?? "Rechercher"}
        className={cn(
          "bg-white border border-gray-100 block py-2 px-3 rounded-sm w-full text-dark placeholder:text-grayMedium text-sm font-medium outline-none shadow-md focus:outline-primary transition-all duration-300 ease-in search__input truncate",
          variant === "small" && "py-1",
          variant === "large" && "py-3",
          variant === "default" && "py-2"
        )}
        id="search"
        value={value}
        onChange={(e) => onChange?.(e.target.value)}
      />
      <span
        className={cn(
          "absolute top-3 right-2 text-grayDark",
          variant === "small" && "top-2",
          variant === "large" && "top-3.5"
        )}
      >
        <BiSearch fontSize={20} />
      </span>
    </label>
  );
};
